import { useIntl } from "@services/i18n";

export const useYesNoField = () => {
  const intl = useIntl();

  const getYesNoOptions = () => ({
    items: [
      { valor: true, texto: intl.i18n.t('shared.ui.literals.yes') },
      { valor: false, texto: intl.i18n.t('shared.ui.literals.no') }
    ],
    valueExpr: 'valor',
    displayExpr: 'texto',
    layout: 'horizontal'
  });

  return {
    getYesNoOptions
  };
}; 